import { render, staticRenderFns } from "./CubicDal-Ai.vue?vue&type=template&id=9674277a&"
import script from "./CubicDal-Ai.vue?vue&type=script&lang=js&"
export * from "./CubicDal-Ai.vue?vue&type=script&lang=js&"
import style0 from "./CubicDal-Ai.vue?vue&type=style&index=0&id=9674277a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports